import { DNA } from '../visual-language'

export function logoStyles({ kind = 'primary' }: LogoStylesProps = {}) {
  return {
    Logo: {
      height: 40,
      width: 100,
    },
    T: {
      fill: kindStyles[kind].T,
    },
    Disc: {
      fill: kindStyles[kind].disc,
    },
  }
}

export interface LogoStylesProps {
  /** Changes appearance of logo. */
  kind?: keyof typeof kindStyles
}

const kindStyles = {
  primary: {
    T: DNA.tokens.alias.color.secondary,
    disc: DNA.tokens.color.telstra,
  },
  secondary: {
    T: DNA.tokens.color.white,
    disc: DNA.tokens.alias.color.secondary,
  },
  tertiary: {
    T: DNA.tokens.color.white,
    disc: DNA.tokens.color.telstra,
  },
}
